import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgNotAllowedLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M4.21997 4.21997L19.78 19.78M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgNotAllowedLarge.displayName = 'SvgNotAllowedLarge';
const NotAllowedLarge = withForgeIconProps(SvgNotAllowedLarge, {
  name: 'NotAllowed',
  usage:
    'Use to indicate an item or service that is not available or not allowed.',
  related: 'prohibit, no, none',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default NotAllowedLarge;
